// import logo from '../logo_square_transparent.png';
import '../App.css';
import CountUp from 'react-countup';
import { businesses } from '../data/businesses';
import { stats, mainPageText } from "../data/general"
import Rellax from 'rellax';
import { useEffect, useRef } from 'react';
import Footer from './Footer/Footer';
import MyCalendar from './Calendar/CalendarModule';
import Background from './Background/Background';
import Mission from './Mission/Mission';
import Intro from './Intro/Intro';
import FeaturedBusiness from './FeaturedBusiness/FeaturedBusiness';
import log from '../images/TCL_logoFullColor1.png'
import Mynavbar from './mynavbar'

function MainPage() {

    // var rellax = new Rellax('.rellax');
    const rellaxRef = useRef();

    // useEffect(() => {
    //     new Rellax(".rellax", { // <---- Via class name
    //         speed: -10,
    //         center: false,
    //         wrapper: null,
    //         round: true,
    //         vertical: true,
    //         horizontal: false
    //     });

    //     new Rellax(rellaxRef.current, { // <---- Via useRef element
    //         speed: -10,
    //         center: false,
    //         wrapper: null,
    //         round: true,
    //         vertical: true,/*  */
    //         horizontal: false
    //     });
    // }, []);

    return (
        <div className="App">
            <Mynavbar />
            <Background />

            <div className="App-header foreground">
                <img src={log} className="App-logo" alt="logo" />
            </div>

            {/* <Intro /> */}
            {/* 
            <FeaturedBusiness />

            <div className='main-cards counter-section foreground'>

                <div className='counter-text'>{mainPageText.counterText}</div>
                <div className='vertical-line'></div>
                <div className='counter-container'>
                    <span>Featured Businesses</span>
                    <CountUp className="count-up" end={stats.businesses} duration={2} />
                </div>
                <div className='counter-container'>
                    <span>Featured Products</span>
                    <CountUp className="count-up" end={stats.items} duration={2} />
                </div>
            </div>

            <div className='main-cards business-section foreground'>
                <span className='business-section-header'>{mainPageText.businessesIntro}</span>
                <hr></hr>
                <div className='business-card-container'>
                    {businesses.map((biz, index) => (
                        <div
                            className='business-card'
                            style={{ "background": biz.background }}
                            key={biz.id || index}  
                        >
                            {biz.name}
                            <div className='business-image-container'>
                                <img src={biz.image} className='business-image' alt='' loading="lazy" />
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            <Mission /> */}

            <div style={{ width: '95%' }}>
                <MyCalendar />
            </div>

            <Footer />

        </div>
    );
}

export default MainPage;